import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { ButtonGroup, Notification, Spacer, Typography } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const ViewsToggle = ({
  viewType,
  setViewType,
  formErrors,
  productSelected
}) => {
  const {
    iotOrderDetailsSection: {
      labelSimpleView,
      labelAdvancedView,
      labelSassOfferingView,
      labelOptionalTechnicalServicePricing
    },
    contentfulValues: {
      valueFleetcomplete,
      valueRaven,
      valueNorthStarSystems,
      valueNorthStarSystemsFarmAndRanch,
      valueFillipFleet,
      valuePowerFleet,
      valueGeoforce
    }
  } = useLocalizedStringsContext();

  const errorMessage = _.get(formErrors, 'viewToggleButtons.text', '');
  const isSimpleViewHidden = [valueFleetcomplete, valueRaven, valuePowerFleet].includes(
    productSelected
  );
  const isBothButtonsHidden = [
    valueNorthStarSystems,
    valueNorthStarSystemsFarmAndRanch,
    valueFillipFleet,
    valueGeoforce
  ].includes(productSelected);

  const labelSimple = [
    valueNorthStarSystems,
    valueNorthStarSystemsFarmAndRanch,
    valueFillipFleet
  ].includes(productSelected)
    ? labelSassOfferingView
    : labelSimpleView;
  const labelAdvanced = [
    valueNorthStarSystems,
    valueNorthStarSystemsFarmAndRanch,
    valueFillipFleet
  ].includes(productSelected)
    ? labelOptionalTechnicalServicePricing
    : labelAdvancedView;

  useEffect(() => {
    if (!isBothButtonsHidden && isSimpleViewHidden) setViewType('advancedView');
    if(productSelected === valueFillipFleet || productSelected === valueGeoforce) setViewType('advancedView');
    if (
      [
        valueNorthStarSystems,
        valueNorthStarSystemsFarmAndRanch
      ].includes(productSelected)
    )
      setViewType('simpleView');
  }, []);

  return (
    <>
      {!isBothButtonsHidden && (
        <>
          <ButtonGroup
            items={[
              ...(!isSimpleViewHidden ? [{ label: labelSimple, id: 'simpleView' }] : []),
              { label: labelAdvanced, id: 'advancedView' }
            ]}
            values={[viewType]}
            onChange={(selectedValues) => {
              if (selectedValues.length > 0) {
                setViewType(selectedValues[0]);
              }
            }}
          />
          {errorMessage && (
            <>
              <Spacer space={1} />
              <Notification variant={{ validation: 'error' }}>
                <Typography>{errorMessage}</Typography>
              </Notification>
            </>
          )}
        </>
      )}
    </>
  );
};

ViewsToggle.propTypes = {
  productSelected: PropTypes.string.isRequired,
  viewType: PropTypes.string.isRequired,
  setViewType: PropTypes.func.isRequired,
  formErrors: PropTypes.shape({}).isRequired
};

export default ViewsToggle;
